import { IRootState } from '../../../../../store'
import { IRevisedTraumaScoreState } from '../store/revisedTraumaScore.types'

export const getRevisedTraumaScoreSelector = (state: IRootState): IRevisedTraumaScoreState => state.revisedTraumaScore
